const path = 'AdminNotifications';
const API_PATH = 'admin-panal/tenant-notifications/send-notification-to-companies';

export const AdminNotificationsActions = {
   SEND_NOTIFICATIONS_TO_COMPANIES: `${path}/sendNotificationsToCompanies`,
};

export const AdminNotificationsAPIsConstants = { API_PATH };
